import { ForemanDB } from '../../types/IndexedDB/ForemanDB'

export const getForemanStagedPalletsFB = async (db: ForemanDB) => {
	const pallets = await db.pallets.toArray()
	const palletItems = await db.palletItems.toArray()
	for (const item of palletItems) {
		const hierarchy: string[] = []

		let palletWorkItem = await db.workItems.get(item.workItemId)
		while (palletWorkItem) {
			hierarchy.push(palletWorkItem.name)
			palletWorkItem = palletWorkItem.parentId
				? await db.workItems.get(palletWorkItem.parentId)
				: undefined
		}
		hierarchy.reverse()
		const workItemPath = hierarchy.join(' > ')
		item.workItemPath = workItemPath
	}
    pallets.forEach((p) => {
        p.palletItems = palletItems.filter((pi) => pi.palletId === p.palletId)
    })
	return pallets
}
